import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight, ExternalLink } from "lucide-react";
import { fmtDrawDate, Trend } from "@/pages/Draws";

export function DrawHistory({ stream }) {
  const rounds = stream.draws || [];
  if (rounds.length === 0) return null;
  const latest = rounds[0];
  const scored = rounds.find((r) => r.cutoff != null);
  const hasScore = stream.score != null && scored != null;
  const diff = hasScore ? stream.score - scored.cutoff : null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="draw-history">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#0F172A] text-white"><CalendarDays className="h-5 w-5" /></span>
          <div>
            <h3 className="font-heading text-base font-semibold text-slate-900">Recent invitation rounds</h3>
            <p className="text-xs text-slate-500">Latest {fmtDrawDate(latest.date)} · {latest.note}</p>
          </div>
        </div>
        <Trend rounds={rounds} />
      </div>
      {hasScore && (
        <p className={`mt-4 rounded-lg px-3 py-2 text-sm font-medium ${diff >= 0 ? "bg-emerald-50 text-emerald-700" : "bg-[#FEF2F2] text-[#991B1B]"}`} data-testid="draw-compare">
          {diff >= 0 ? `Your score of ${stream.score} would have cleared the latest scored round (${scored.cutoff}, ${scored.note}) by ${diff}.` : `Your score of ${stream.score} is ${-diff} below the latest scored round of ${scored.cutoff} (${scored.note}).`}
        </p>
      )}
      <ul className="mt-4 divide-y divide-slate-100 text-sm">
        {rounds.slice(0, 4).map((r) => (
          <li key={r.date + r.note} className="flex items-center justify-between gap-3 py-2">
            <span className="text-slate-600">{fmtDrawDate(r.date)} <span className="text-slate-400">· {r.note}</span></span>
            <span className="shrink-0"><span className="font-mono-tech font-semibold text-slate-900">{r.cutoff ?? "—"}</span> <span className="text-xs text-slate-400">· {r.invitations ?? "—"} ITAs</span></span>
          </li>
        ))}
      </ul>
      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1">
        <Link to="/draws" data-testid="draw-history-all" className="inline-flex min-h-[44px] items-center gap-1 text-sm font-semibold text-[#C8102E] hover:underline">All streams' draw history <ArrowRight className="h-4 w-4" /></Link>
        {stream.draw_link && <a href={stream.draw_link.url} target="_blank" rel="noreferrer" data-testid="draw-history-official" className="inline-flex min-h-[44px] items-center gap-1 text-sm font-semibold text-slate-600 hover:underline">{stream.draw_link.label} <ExternalLink className="h-3.5 w-3.5" /></a>}
      </div>
    </div>
  );
}
